<template>
  <div class="dock">
    <div class="dock-container">
      <div v-for="(dock, index) in dockList" :key="index" class="mx-2">
        <router-link :to="{ name: dock.name, params: { tab_id: dock.tab_id } }">
          <li v-for="(image, imageIndex) in dock.image" :key="image" class="li-1" :class="{ router: $router.path }">
            <div class="name">
              {{ dock.name }}
            </div>
            <img :key="imageIndex" :src="image" class="ico" />
          </li>
        </router-link>
      </div>

      <Button icon="pi pi-arrow-up" class="mr-2" @click="visibleBottom = true" />
      <Button type="button" label="Toggle" @click="toggle" />
      <Menu ref="menu" :model="dialogs" :popup="true" />
    </div>
  </div>
  <div v-if="visibleBottom" class="dock-tray-backdrop" @click="visibleBottom = false" />
  <div v-if="visibleBottom" class="dock-bottom-tray" @click.stop>
    <Button icon="pi pi-times" text rounded class="dock-bottom-tray-close" @click="visibleBottom = false" />
    <div class="dock-bottom-tray-content">
      <div v-for="win in minimizedWindows" :key="win.data.windowId" class="dock-tray-item"
        v-tooltip.top="win.data.label" @click="restoreWindow(win)">
        <img :src="iconSrc(win)" class="dock-tray-item-ico" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["dialogs"],
  data() {
    return {
      visibleBottom: false,
      path: "",
      minimizedWindows: [],
      dockList: [
        {
          name: "Dashboard",
          image: [require("../assets/images/icons/128x128/FolderWithStar.png")],
          path: "/",
          tab_id: 1,
        },
        {
          name: "accounting",
          image: [require("../assets/images/icons/128x128/Calculator.png")],
          path: "/accounting",
          tab_id: 2,
        },
        {
          name: "Payables",
          image: [
            require("../assets/images/icons/128x128/CalculatorWithFolder.png"),
          ],
          path: "/payables",
          tab_id: 3,
        },
        {
          name: "Payroll",
          image: [
            require("../assets/images/icons/128x128/FileWithTextAndFont.png"),
          ],
          path: "/payroll",
          tab_id: 4,
        },
        {
          name: "Billing",
          image: [require("../assets/images/icons/128x128/Checkbook.png")],
          path: "/billing",
          tab_id: 5,
        },
        {
          name: "Assets",
          image: [require("../assets/images/icons/128x128/Briefcase.png")],
          path: "/assets",
          tab_id: 6,
        },
        {
          name: "Reports",
          image: [require("../assets/images/icons/128x128/Chart.png")],
          path: "/reports",
          tab_id: 7,
        },
        {
          name: "Time",
          image: [require("../assets/images/icons/128x128/Alarm.png")],
          path: "/time",
          tab_id: 8,
        },
        {
          name: "Jobs",
          image: [require("../assets/images/icons/128x128/FolderWithUser.png")],
          path: "/jobs",
          tab_id: 9,
        },
        {
          name: "CRM",
          image: [require("../assets/images/icons/128x128/GraphMoney.png")],
          path: "/crm",
          tab_id: 10,
        },
        {
          name: "Tools",
          image: [require("../assets/images/icons/128x128/Gear.png")],
          path: "/tools",
          tab_id: 11,
        },
        {
          name: "Files",
          image: [
            require("../assets/images/icons/128x128/FolderWithFolders.png"),
          ],
          path: "/files",
          tab_id: 12,
        },
        {
          name: "Calendar",
          image: [require("../assets/images/icons/128x128/Calendar.png")],
          path: "/calendar",
          tab_id: 13,
        },
        {
          name: "Messages",
          image: [require("../assets/images/icons/128x128/Comment.png")],
          path: "/messages",
          tab_id: 14,
        },
        {
          name: "Planner",
          image: [require("../assets/images/icons/128x128/WindowWithText.png")],
          path: "/planner",
          tab_id: 15,
        },
      ],
    };
  },
  mounted() {
    this.emitter.on("minimized-windows", (list) => {
      this.minimizedWindows = list;
      if (list.length) {
        this.visibleBottom = true;
      } else {
        this.visibleBottom = false;
      }
    });
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    toggleDialog(dialog) {
      this.$emit("toggle-dialog", dialog);
    },
    restoreWindow(win) {
      this.emitter.emit("restore-window", win.data.windowId);
    },
    iconSrc(win) {
      const name =
        win.data.service?.favicon ||
        win.data.service?.icon ||
        "FolderWithStar";
      try {
        return require("@/assets/images/icons/128x128/" + name + ".png");
      } catch (e) {
        return require("@/assets/images/icons/128x128/FolderWithStar.png");
      }
    },
  },
};
</script>

<style lang="scss">
.dock-tray-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.dock-bottom-tray {
  position: fixed;
  left: 0;
  right: 0;
  width: 100vw;
  bottom: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 80px;
  padding: 0.5rem 1rem;
  background: #ffffff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

.dock-bottom-tray-close {
  flex-shrink: 0;
}

.dock-bottom-tray-content {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.75rem;
}

.dock-tray-item {
  cursor: pointer;
  flex-shrink: 0;
}

.dock-tray-item-ico {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
</style>
